/**
 * This is the opposite to the LazyComponent
 * Takes the Component passed as a param, and wraps it with the basic <section id="moduleId">
 */
const EagerComponent = (props) => <section id={props.id} {...props}>{props.children}</section>

export default EagerComponent